/**
 * Created by Mike Naughton on 2/16/18.
 */

import modernizr from "modernizr-base";

modernizr.addTest("draganddrop", function () {
  var div = document.createElement("div");
  return "draggable" in div || ("ondragstart" in div && "ondrop" in div);
});

export default modernizr;



//////////////////
// WEBPACK FOOTER
// ./public/lib/js/modernizr-shim.js
// module id = 349
// module chunks = 1